// AF extraireRsp structures
export interface extractRSPsHTTPResponse {
	HTTPResponse: {
		codeRetour: string,
		libRetour: string,
		idSession: string,
		extractRSPs: ExtractRSPs;
	};
};

export class ExtractRSPs {
  dateHeureGeneration!: string; // date de génération de cette extraction (calculée par le serveur)
  fichierRSP: FichierRSP[] = []; // message RSP reçu de la caisse
}

export class FichierRSP {
  typeEmetFic!: string; // type d'emetteur
  numEmetFic!: string; // identifie l'AMO ou AMC
  typeDestFic!: string; // en général TP
  numDestFic!: string; // en général l'IDFAC du PS
  nomFic!: string; // nom du fichier dans le SI de l'emetteur
  dateFic!: string; // date de création du fichier dans le SI de l'emetteur JJMMAA
  norme!: string; // 531, 532, … 580, 900
  numMandat?: string; // mandataire de règlement si différent du PS
  numDestRegl?: string; // en général l'IDFAC du PS
  topRSPDRE!: boolean; // 0: il s'agit d'un RSP de FSE, 1: RSP de DRE
  idFic?: string; // identifiant unique du fichier RSP dans la base AreaFSE
  RSP: RSP[] = []; // détail du règlement, du signalement ou du paiement
}

export class RSP {
  dateComptable!: string; // jour ou le virement est fait JJMMAA
  refLot!: string;  // numero de lot
  dateLot!: string; // date de creation du lot JJMMAA
  numFacture!: string; // numero de la FSE ou DRE
  dateFacture?: string; // date de facturation [Réf. 580 uniquement] JJMMAA
  numSecu?: string; // numéro de sécurité sociale de l'assuré
  dateNaissBenef?: string; // date de naissance du bénéficiaire JJMMAA
  rangNaiss?: number; // rang de naissance du bénéficiaire
  nomBenef?: string; // nom du bénéficiaire
  prenomBenef?: string; // prénom du bénéficiaire
  typeRetour!: string; // RP, RJ, 01,02,03,04,05
  risque?: string; // AS=Maladie, AT=Accident du travail, MA=Maternité
  numOC?: string; // ent 010 rare
  lienArchiv?: string; // identifiant d'archivage des pièces du dossier
  libVirement1?: string; // libellé du virement bancaire
  libVirement2?: string; // libellé du virement bancaire
  opReglementAMC?: string; // opérateur de règlement de l'AMC
  traitementPartAMC?: string; // traitement effectué sur la part AMC
  totalPaiement!: number; // montant du remboursement
  totalAMO?: number; // total des nœuds <acte> et <partAMO>
  totalAMC?: number; // total des nœuds <acte> et <partAMC>
  totalMFI?: number; // total des nœuds <MFI> (avec signe)
  totalAutrePaiement?: number; // total des nœuds <autrePaiement>
  premierRejet?: string; // premier rejet ou premier libelle autre paiement ou premier commentaire
  topPaiement!: string; // presence de remboursement
  topRejet!: string; // présence de rejet(s)
  topDiffere!: string; // presence de différé(s)
  acte: Acte[] = []; // [Hors Réf. 580]
  partAMO?: PartAMO; // ent 198 [Réf. 580 uniquement]
  partAMC?: PartAMC; // ent 199 [Réf. 580 uniquement]
  MFI?: MFI; // ent 250 : retenue ou remboursement reliquat
  autrePaiement: AutrePaiement[] = []; // ent 260 paiement pontuel ou forfaitaire [Réf. 580 uniquement]
  rejet: Rejet[] = []; // ent 294/290
  commentaire: Commentaire[] = []; // ent 295 [Réf. 580 uniquement]

  // Derived from FichierRSP. Denormalized
  norme!: string;   // Norme du fichier RSP
  typeEmetFic!: string; // type d'emetteur
  numEmetFic!: string; // identifie l'AMO ou AMC  
}

export class Acte {
  dateExec!: string; // date d'exécution JJMMAA
  codePresta!: string; // code prestation
  montantRemboursementAMO!: number; // montant remboursé pour la part obligatoire
  montantRemboursementAMC?: number; // montant remboursé pour la part complémentaire
}

export class PartAMO {
  montantDemande?: number; // montant du remboursement demandé sur la FSE
  traitement?: string; // P,R,D,blanc : traitement différé ou payé
  montantPaiement!: number; // montant remboursé pour la part obligatoire
}

export class PartAMC {
  montantDemande?: number; // montant du remboursement demandé sur la FSE ou DRE
  traitement?: string; // P,R,D,blanc : traitement différé ou payé
  montantPaiement!: number; // montant remboursé pour la part complémentaire
  numDestAMC?: string;
  idAdherent?: string;
}

export class MFI {
  refDette!: string; // référence de la dette
  dateDette!: string; // date d'enregistrement de la dette
  natureDette!: string; // type de reliquat
  natureOperation!: string; // opération de régularisation
  montantMFI!: number; // peut être positif ou négatif
  montantSolde?: number; // montant restant après régularisation
}

export class AutrePaiement {
  code!: string; // code ax10b2
  montantPaiement!: number; 
  detailAutrePaiement?: DetailAutrePaiement[];
}

export class DetailAutrePaiement {
  code?: string;
  libelle?: string;
  numSecuOuvrantDroits?: string;
  dateNaissOuvrantDroits?: string;
  rangNaiss?: number;
  periode?: string;
  dateDebutPeriode?: string;
  dateFinPeriode?: string;
  montantPaiement!: number;
}

export class Rejet {
  code!: string; // code du rejet
  libelle!: string; // libellé du rejet
  niveau?: string; // F : facture, L:ligne, A:code affiné [Réf. 580]
  partConcernee?: string; // O: oblig, C: complémentaire [Réf. 580]
  naturePresta?: string; // ax10b2 [Réf. 580]
  dateExec?: string; // date d'exécution [Réf. 580]
  numExec?: string; // identifiant exécutant [Réf. 580]
  numLigne?: number; // numéro ligne facture [Réf. 580]
  rangRejet?: number; // numéro du code affiné [Réf. 580]
  infoCompl?: string; // infos concises pour retraitement [Réf. 580]
}

export class Commentaire {
  code?: string; // A blanc = PS, autres codifications réservées inter-organismes
  commentaire!: string; // commentaire envoyé par la caisse
}

export interface FseRsp {	// Table fse_rsp
	id: number;									 // id
  idFic: string;               // id_fic
  typeEmetFic: string;         // type_emet_fic
  numEmetFic: string;          // num_emet_fic
  typeDestFic: string;         // type_dest_fic
  numDestFic: string;          // num_dest_fic
  nomFic: string;              // nom_fic
  dateFic: string;             // date_fic (ISO string: e.g. "2025-10-24T00:00:00Z")
  norme: string;               // norme
  numMandat: string;           // num_mandat
  numDestRegl: string;         // num_dest_regl
  topRSPDRE: string;           // top_rspdre
  numFacture: string;          // num_facture
  typeRetour: string;          // type_retour
  risque: string;              // risque
  dateComptable: string;       // date_comptable (ISO string)
  numSecu: string;             // num_secu
  data: any;                   // data (can be JSON, object, or string depending on DB column type)

  etat:string;                 // Derived values to flatten/precompute data
}

